import { Paper, Box } from '@mui/material';
import { forwardRef } from 'react';

export const CardSurface = forwardRef(({ children, blur = true, ...props }, ref) => {
  return (
    <Paper
      ref={ref}
      elevation={0}
      {...props}
      sx={{
        borderRadius: '14px',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        background: blur
          ? 'rgba(255, 255, 255, 0.8)'
          : 'rgba(255, 255, 255, 1)',
        backdropFilter: blur ? 'blur(12px)' : 'none',
        WebkitBackdropFilter: blur ? 'blur(12px)' : 'none',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.06)',
        ...props.sx,
      }}
    >
      {children}
    </Paper>
  );
});

CardSurface.displayName = 'CardSurface';
